module.exports = __webpack_public_path__ + "static/img/barra_9.5012bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_9.png
// module id = zPmT
// module chunks = 1